import { TypeFilterValueKey } from '../../../common/constants/filters/universal-type';
import { useSelectedFilters } from './index';

export const useCommentsFilterActive = (): boolean => {
	// Parent analytics use URL filters; rows use the asynchronously hydrated store.
	// Hoist the exact row source once so transitions preserve both contracts.
	const { selectedEntities } = useSelectedFilters({});
	return selectedEntities.includes(TypeFilterValueKey.Comment);
};
